import {SearchStateModel} from './model';

export class UpdateSearchQueryAction {
  static readonly type = '[Search] Update Search Query';
  constructor(public query: string) {
  }
}

export class ClearSearchQueryAction {
  static readonly type = '[Search] Clear Search Query';
}

export class SetSearchLoadingAction {
  static readonly type = '[Search] Set Search Loading';
  constructor(public loading: boolean) {
  }
}

export class SetSearchStateAction {
  static readonly type = '[Search] Set Search State';
  constructor(public state: SearchStateModel) {
  }
}
